const Text = ({onChange, id, placeholder, value}) => {
    return (
        <>
            <input onChange={onChange} value={value} id={id} type='text' placeholder={placeholder} name={id}/>
        </>
    )
}

export default Text